import { ConditionEqualityType } from "../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField } from "../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../api/types/svTypes.ts";
import { isReferenceDateField } from "../../components/builder/common/utilities/isReferenceDateField.ts";

// A List condition compiles literally into the WHERE clause, so LessThanOrEqual keeps as-of semantics.
export const withListDateEqualityDefault = (condition: ConditionField): ConditionField => {
  if (!isReferenceDateField(condition.meta) || !condition.config.filter) {
    return condition;
  }
  const equalityType = condition.config.filter.equalityType;
  if (equalityType && equalityType !== ConditionEqualityType.Equal) {
    return condition;
  }
  return {
    ...condition,
    config: {
      ...condition.config,
      filter: { ...condition.config.filter, equalityType: ConditionEqualityType.LessThanOrEqual },
    },
  };
};

const dateEqualityTypesOutsideList = [ConditionEqualityType.Equal, ConditionEqualityType.NotEqual];

// Only the List builder exposes the date operator, so a List-only one must not outlive the report type.
export const withoutListDateEquality = (condition: ConditionField): ConditionField => {
  const filter = condition.config.filter;
  if (condition.meta.type !== ItemDataType.Date || !filter) {
    return condition;
  }
  if (filter.equalityType === undefined || dateEqualityTypesOutsideList.includes(filter.equalityType)) {
    return condition;
  }
  return {
    ...condition,
    config: { ...condition.config, filter: { ...filter, equalityType: ConditionEqualityType.Equal } },
  };
};
